import { FTAction, NFTAction, Transaction } from '@/api/cspr-cloud-types';
import { Message } from '@/entities';
import { StampAction } from '@/entities/stamp-action';

function byteArrayToHex(bytes: Array<number> ) {
  return Uint8Array.from(bytes)
    .reduce((acc, b) => acc + b.toString(16).padStart(2, '0'), '');
}
export function fromNFTActionToMessage(action: NFTAction): Message {
  return {
    id: action.token_id,
    isFailed: false,
    parentId: action.deploy?.args?.parent_id?.parsed,
    threadId: action.deploy?.args?.thread_id?.parsed,
    recipientPublicKey: action.deploy?.args?.recipient?.parsed,
    body: byteArrayToHex(action.deploy?.args?.body?.parsed),
    sendersCopy: byteArrayToHex(action.deploy?.args?.senders_copy?.parsed),
    senderPublicKey: action.deploy?.args?.sender?.parsed,
    timestamp: action.timestamp,
    transactionHash: action.deploy_hash,
  };
}

export function fromTransactionToMessage(transaction: Transaction): Message {
  return {
    id: transaction?.nft_token_actions && transaction?.nft_token_actions.length > 0
      ? transaction.nft_token_actions[0].token_id
      : null,
    isFailed: !transaction?.nft_token_actions || transaction?.nft_token_actions.length === 0,
    parentId: transaction.args?.parent_id?.parsed,
    threadId: transaction.args?.thread_id?.parsed,
    recipientPublicKey: transaction.args?.recipient?.parsed,
    body: byteArrayToHex(transaction.args?.body?.parsed),
    sendersCopy: byteArrayToHex(transaction.args?.senders_copy?.parsed),
    senderPublicKey: transaction.args?.sender?.parsed,
    timestamp: transaction.timestamp,
    transactionHash: transaction.deploy_hash
  };
}

export function fromFTActionToStampAction(action: FTAction): StampAction {
  return {
    amount: parseInt(action.amount),
    ftActionTypeId: action.ft_action_type_id,
    timestamp: action.timestamp,
    transactionHash: action.deploy_hash,
    sourcePublicKey: action.from_public_key,
    sourceHash: action.from_hash,
    sourceType: action.from_type,
    targetPublicKey: action.to_public_key,
    targetHash: action.to_hash,
    targetType: action.to_type,
  }
}
